import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { Box, Button, Modal, Stack } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAPI, useSystemActions } from 'stores';
import { InputFieldProps } from 'types';
import { ModalBoxStyle } from '../ModalBox/styles';

interface ImageTagProps {
	img?: string;
}

const ImageTag = ({
	img,
	getValues,
	setValue,
}: ImageTagProps & InputFieldProps) => {
	const [open, setOpen] = useState(false);
	const { t } = useTranslation();
	const { getImage } = useSystemActions();
	const { uploadImage } = useAPI();

	const getImageURL = () => {
		if (img)
			return `${process.env.REACT_APP_DOMAIN_NAME}${process.env.REACT_APP_API_GET_IMAGE}?name=${img}`;
		return `${getImage('img_upload.png')}`;
	};
	const handleImagePreview = () => {
		setOpen(true);
	};
	const handleImageDelete = () => {
		const imgsArr = (getValues && getValues('imgs')) || [];
		setValue &&
			setValue(
				'imgs',
				imgsArr.filter((item: string) => item !== img)
			);
	};
	const handleImageUpload = async (
		e: React.ChangeEvent<HTMLInputElement>
	) => {
		e.preventDefault();
		if (!e.target.files || !e.target.files.length) return;
		const files = e.target.files;
		const imgsArr = (getValues && getValues('imgs')) || [];
		if (files.length + imgsArr.length > 3) {
			enqueueSnackbar(t('feedback.imgs.reach.max'), {
				variant: 'warning',
			});
		}
		for (let i = 0; imgsArr.length < 3 && i < files.length; i++) {
			const file = files[i];
			const response = await uploadImage(file); //	catch error?
			imgsArr.push(response.data[0]);
			setValue && setValue('imgs', imgsArr);
		}
	};

	return (
		<>
			<Stack
				sx={{
					backgroundColor: 'background.default',
					backgroundImage: `url(${getImageURL()})`,
					backgroundSize: '100% 100%',
					borderRadius: '8px',
					width: '64px',
					height: '64px',
				}}
				direction="row"
				alignItems="center"
				justifyContent="center"
			>
				{img ? (
					<>
						<VisibilityOutlinedIcon
							sx={{ color: 'white', fontSize: 20 }}
							onClick={handleImagePreview}
						/>
						<DeleteOutlineIcon
							sx={{ color: 'white', fontSize: 20 }}
							onClick={handleImageDelete}
						/>
					</>
				) : (
					<>
						<Button
							disableRipple
							sx={{ width: '64px', height: '64px' }}
							component="label"
						>
							<input
								hidden
								type="file"
								accept="image/*"
								multiple
								onChange={handleImageUpload}
							/>
						</Button>
					</>
				)}
			</Stack>
			{img ? (
				<Modal
					open={open}
					onClose={() => {
						setOpen(false);
					}}
				>
					<Box
						sx={ModalBoxStyle}
						component="img"
						src={getImageURL()}
					/>
				</Modal>
			) : null}
		</>
	);
};

export default ImageTag;
